import Image from 'next/legacy/image'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { colors, fontWeights } from '@/styles'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 375px;
  padding: 20px;
  height: 440px;
  margin-bottom: 40px;
  flex-shrink: 0;
`

const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
`

const TextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const PlanText = styled.p`
  font-size: 18px;
  font-weight: ${fontWeights.medium};
  text-align: center;
  margin: 8px 0 24px;
`

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  min-height: 45px;
  color: ${colors.white};
  width: 180px;
  padding: 0 25px;
  font-size: 16px;
  background-color: #445e54;
  text-decoration: none;
  border-width: 1px;
  font-weight: ${fontWeights.regular};
  &:disabled {
    opacity: 0.9;
  }
`

const Floorplan = ({ image, bed, link }) => {
  const { t } = useTranslation('w2living')
  const formattedPlanText = `${bed}-${t('w2living:Bedroom')}`
  return (
    <Container>
      <ImageWrapper>
        <Image
          src={image}
          alt={`${bed} bedroom unit Image`}
          layout="fill"
          objectFit="cover"
          placeholder="blur"
        />
      </ImageWrapper>
      <TextWrapper>
        <PlanText>{formattedPlanText}</PlanText>
        <Link href={link} passHref legacyBehavior>
          <StyledButton
            theme="primary"
            shadow
            as="a"
            rel="noreferrer"
            target="_blank"
          >
            {t('w2living:Check Availability')}
          </StyledButton>
        </Link>
      </TextWrapper>
    </Container>
  )
}

export default Floorplan
